import { IconWorkHome, IconConstruction, IconNotifications, IconFilledDatabase } from "@/assets/icons";
import { AppRoutes, OrganizationManagementRoutes, SystemSettingRoutes, MasterDataRoutes, InformationRoutes } from "@/routes/config";
import { TMenu } from "@/types/menu";

// Get version from environment variable
const APP_VERSION = process.env.REACT_APP_VERSION || "0.1";

// Helper function to check if menu should be visible based on version
export const isMenuVisible = (minVersion?: string, maxVersion?: string): boolean => {
  if (!minVersion && !maxVersion) return true;

  const currentVersion = parseFloat(APP_VERSION);
  const min = minVersion ? parseFloat(minVersion) : 0;
  const max = maxVersion ? parseFloat(maxVersion) : Infinity;

  return currentVersion >= min && currentVersion <= max;
};

// Menu configuration with version-based visibility
// You can add minVersion and maxVersion to control when menu items are visible
// Example: visible: isMenuVisible("0.2") - only show from version 0.2 onwards
// Example: visible: isMenuVisible("0.1", "0.5") - show only between version 0.1 and 0.5
const menuConfig: TMenu[] = [
  {
    text: "登録支援機関向け",
    children: [
      {
        text: "組織管理",
        icon: IconWorkHome,
        path: AppRoutes.organizationList,
        relatedRoutes: OrganizationManagementRoutes,
        visible: isMenuVisible("0.1"),
      },
    ],
  },
  {
    text: "システム管理",
    children: [
      {
        text: "お知らせ配信",
        icon: IconNotifications,
        path: AppRoutes.information,
        relatedRoutes: InformationRoutes,
        visible: isMenuVisible("0.1"),
      },
      {
        text: "マスターデータ管理",
        icon: IconFilledDatabase,
        path: AppRoutes.masterData,
        relatedRoutes: MasterDataRoutes,
        visible: isMenuVisible("0.1"),
      },
      {
        text: "システム設定",
        icon: IconConstruction,
        path: AppRoutes.emailSetting,
        relatedRoutes: SystemSettingRoutes,
        visible: isMenuVisible("0.1"),
      },
    ],
  },
];

// Process menus to set visible property based on version
// If visible is not set, it defaults to true (menu will be shown)
export const menus: TMenu[] = menuConfig.map((menu) => ({
  ...menu,
  visible: menu.visible !== undefined ? menu.visible : true,
  children: menu.children?.map((child) => ({
    ...child,
    visible: child.visible !== undefined ? child.visible : true,
  })),
}));
